export default {
  FETCH_QUESTIONS_REQUEST: 'FETCH_SIGNUP_FORM_QUESTIONS_REQUEST',
  FETCH_QUESTIONS_SUCCESS: 'FETCH_SIGNUP_FORM_QUESTIONS_SUCCESS',
  FETCH_QUESTIONS_FAILURE: 'FETCH_SIGNUP_FORM_QUESTIONS_FAILURE',
  UPDATE_QUESTIONS: 'UPDATE_SIGNUP_FORM_QUESTIONS',
  SAVE_QUESTIONS_REQUEST: 'SAVE_SIGNUP_FORM_QUESTIONS_REQUEST',
  SAVE_QUESTIONS_SUCCESS: 'SAVE_SIGNUP_FORM_QUESTIONS_SUCCESS',
  SAVE_QUESTIONS_FAILURE: 'SAVE_SIGNUP_FORM_QUESTIONS_FAILURE'
}
